import styled from 'styled-components';

const PageContainer = styled.div`
`;

export const VideosPage = () => {
  return (
	<PageContainer />
  );
};

export default VideosPage;
